import { render, staticRenderFns } from "./PackageCard.vue?vue&type=template&id=49db5795&"
import script from "./PackageCard.vue?vue&type=script&lang=js&"
export * from "./PackageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FilterResultsTable: require('/usr/src/motec/components/FilterResults/Table.vue').default,Spinner: require('/usr/src/motec/components/Spinner.vue').default,FilterResultsUsefulLinks: require('/usr/src/motec/components/FilterResults/UsefulLinks.vue').default})
